// extracted by mini-css-extract-plugin
export default {"dangerText":"vheKqktH3p"};